import './view.scss';

document.addEventListener('DOMContentLoaded', function () {
    const locationsBlocks = document.querySelectorAll('.locations');

    locationsBlocks.forEach((block) => {
        const filterButtons = block.querySelectorAll('.locations__filter-btn');
        const locationItems = block.querySelectorAll('.locations__item');

        if (filterButtons.length === 0 || locationItems.length === 0) return;

        filterButtons.forEach((button) => {
            button.addEventListener('click', function () {
                const selectedCity = this.getAttribute('data-city');

                // Update active state
                filterButtons.forEach((btn) => btn.classList.remove('locations__filter-btn--active'));
                this.classList.add('locations__filter-btn--active');

                // Filter locations
                locationItems.forEach((item) => {
                    const itemCities = item.getAttribute('data-city');

                    if (selectedCity === 'all') {
                        // Show all items
                        item.style.display = '';
                    } else if (itemCities && itemCities.includes(selectedCity)) {
                        // Show item if it matches the selected city
                        item.style.display = '';
                    } else {
                        // Hide item
                        item.style.display = 'none';
                    }
                });
            });
        });
    });
});


